/* @flow */
import SchoolView from './SchoolView';
import SchoolViewDataContainer from './SchoolViewDataContainer';

export { SchoolView };
export default SchoolViewDataContainer;
